// Phone
export const COMPANY_PHONE_NUMBER = '800-877-7777'

// Operating hours
export const OPERATING_HOURS = 'Weekdays 8AM - 7PM Central'
